/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div role="tablist" class="accordion-list">
    <accordion-manager v-for="accordion in finalRows" :key="accordion.key" :accordion="accordion" :product="product" :variantSelected="variantSelected" />
  </div>
</template>

<script>
import get from 'lodash/get'
import AccordionManager from 'theme/components/Accordion/layouts/AccordionManager'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    variantSelected: {
      type: Array | Object,
      required: false
    }
  },
  data () {
    return {
      finalRows: [],
      rowsMap: [
        {
          rowKey: 'product-detail',
          label: this.$t('product.accordion.product-details'),
          contains: [
            {
              fieldKey: 'long_description',
              label: ''
            },
            {
              fieldKey: 'id',
              label: this.$t('product.accordion.product-code'),
              useComponent: 'AccordionProductCode'
            }
          ]
        },
        {
          rowKey: 'tecnical-data',
          label: this.$t('product.accordion.tecnical-data'),
          useComponent: 'AccordionTecnicalData',
          contains: [
            {
              fieldKey: 'c_colorGroup',
              label: this.$t('product.accordion.product-color')
            },
            {
              fieldKey: 'c_heightClose',
              label: this.$t('product.accordion.product-height-closed')
            },
            {
              fieldKey: 'c_heightOpen',
              label: this.$t('product.accordion.product-height-open')
            },
            {
              fieldKey: 'c_widthClose',
              label: this.$t('product.accordion.product-width-closed')
            },
            {
              fieldKey: 'c_widthOpen',
              label: this.$t('product.accordion.product-width-open')
            },
            {
              fieldKey: 'c_depthClose',
              label: this.$t('product.accordion.product-dept-closed')
            },
            {
              fieldKey: 'c_depthOpen',
              label: this.$t('product.accordion.product-dept-open')
            },
            {
              fieldKey: 'c_diameterClose',
              label: this.$t('product.accordion.product-diameter-open')
            },
            {
              fieldKey: 'c_diameterOpen',
              label: this.$t('product.accordion.product-diameter-open')
            }
            // CN-137 on 24.10.22
            // {
            //   fieldKey: 'c_netWeight',
            //   label: this.$t('product.accordion.product-net-weight')
            // },
            // {
            //   fieldKey: 'c_grossWeight',
            //   label: this.$t('product.accordion.product-gross-weight')
            // }
          ]
        },
        {
          rowKey: 'composition',
          label: this.$t('product.accordion.composition'),
          contains: [
            {
              fieldKey: 'c_careLabel_compo',
              useComponent: 'AccordionCareComposition',
              label: ''
            },
            {
              fieldKey: 'c_careInfo_compo',
              useComponent: 'AccordionCareComposition',
              label: ''
            }
          ]
        },
        {
          rowKey: 'shipping',
          fieldKey: 'c_moreinfo.ShipmentAndReturn',
          label: this.$t('product.accordion.shipping-return')
        },
        {
          rowKey: 'sustainability',
          fieldKey: 'c_moreinfo.Sustainability',
          label: this.$t('product.accordion.sustainability'),
          useComponent: 'AccordionSustainability'
        }
      ]
    }
  },
  methods: {
    recursiveRowsGenerator ({ _this, row }) {
      // if has rows loop it
      let arr = []
      if (row && row.contains) {
        let tmp = []
        row.contains.forEach((el, index) => {
          arr.push({
            label: el.label,
            key: el.fieldKey,
            value: get(_this.product.attributesLabel[el.fieldKey], 'value', ''),
            useComponent: el.useComponent || false,
            contains: el.contains && el.contains.lenght ? _this.recursiveRowsGenerator({ _this, row: el, arr: tmp }) : []
          })
        })
      }
      return arr
    },
    generateRows () {
      const _this = this
      let remapped = []
      this.rowsMap.forEach((row) => {
        remapped.push({
          label: row.label,
          key: row.rowKey,
          useComponent: row.useComponent || false,
          value: get(_this.product.attributesLabel[row.fieldKey], 'value', ''),
          contains: _this.recursiveRowsGenerator({ _this, row })
        })
      })
      this.finalRows = remapped
    }
  },
  mounted () {
    this.generateRows()
  },
  components: {
    AccordionManager
  }
}
</script>
